import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'firstSentence'
})
export class FirstSentencePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return (value) ? value.split('.')[0] : '';
  }

}



// WEBPACK FOOTER //
// /Users/nicholasgerard/Documents/Quibbl/quibbl/src/app/pipes/first-sentence.pipe.ts